/* Toeluna: add lines to the cart and open Horizon's cart drawer (falls back to the cart page). */
(function () {
  if (window.ToelunaCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function readJson(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');
      return data;
    });
  }

  function postAdd(items, sections) {
    var body = { items: items };
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(readJson);
  }

  function goToCart() {
    window.location.href = root + 'cart';
  }

  function openDrawer(drawer) {
    if (drawer && typeof drawer.open === 'function') {
      if (!drawer.isOpen) drawer.open();
      return true;
    }
    return false;
  }

  window.ToelunaCart = {
    add: function (items) {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return postAdd(items).then(goToCart);

      return postAdd(items, 'cart-drawer-section').then(function (added) {
        return import('@shopify/events')
          .then(function (events) {
            var CartEvent = events.CartLinesUpdateEvent;
            var deferred = CartEvent.createPromise();
            document.dispatchEvent(
              new CartEvent({
                action: 'add',
                context: 'product',
                lines: items.map(function (item) { return { merchandiseId: item.id, quantity: item.quantity }; }),
                promise: deferred.promise
              })
            );
            return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(readJson)
              .then(function (cart) {
                deferred.resolve({
                  cart: CartEvent.createCartFromAjaxResponse(cart),
                  detail: {
                    sections: added.sections || undefined,
                    items: cart.items,
                    itemCount: cart.item_count,
                    source: 'toeluna',
                    didError: false
                  }
                });
                setTimeout(function () { if (!openDrawer(drawer)) goToCart(); }, 60);
              });
          })
          .catch(function () { goToCart(); });
      });
    }
  };
})();
